import { ModulePage } from "features/rating_instruments/modules/ModulePage";
import {
  ENDOMETRIAL_BIOPSY,
  INTRA_UTERINE_DEVICE_INSERTION,
  MEDICAL_ABORTION,
  NEW,
  pathsMap,
  PESSARY_FITTING,
  ROUTINE_PESSARY_CARE,
  VULVA_PUNCH_BIOPSY,
  GRS,
} from "navigation/Paths";
import { Outlet, Route } from "react-router-dom";
import { GRSPage } from "../GRSPage";
import { GRS as GRSInstrument } from ".";

// TODO fix types
export const GRSRoutes = ({ context }: any) => (
  <Route path={GRS} element={<Outlet />}>
    <Route index element={<GRSPage />} />
    <Route path={ENDOMETRIAL_BIOPSY} element={<Outlet />}>
      <Route
        index
        element={<ModulePage title={pathsMap[ENDOMETRIAL_BIOPSY]} />}
      />
      <Route
        path={NEW}
        element={
          <GRSInstrument module={ENDOMETRIAL_BIOPSY} context={context} />
        }
      />
    </Route>
    <Route path={INTRA_UTERINE_DEVICE_INSERTION} element={<Outlet />}>
      <Route
        index
        element={
          <ModulePage title={pathsMap[INTRA_UTERINE_DEVICE_INSERTION]} />
        }
      />
      <Route
        path={NEW}
        element={
          <GRSInstrument
            module={INTRA_UTERINE_DEVICE_INSERTION}
            context={context}
          />
        }
      />
    </Route>
    <Route path={VULVA_PUNCH_BIOPSY} element={<Outlet />}>
      <Route
        index
        element={<ModulePage title={pathsMap[VULVA_PUNCH_BIOPSY]} />}
      />
      <Route
        path={NEW}
        element={
          <GRSInstrument module={VULVA_PUNCH_BIOPSY} context={context} />
        }
      />
    </Route>
    <Route path={ROUTINE_PESSARY_CARE} element={<Outlet />}>
      <Route
        index
        element={<ModulePage title={pathsMap[ROUTINE_PESSARY_CARE]} />}
      />
      <Route
        path={NEW}
        element={
          <GRSInstrument module={ROUTINE_PESSARY_CARE} context={context} />
        }
      />
    </Route>
    <Route path={PESSARY_FITTING} element={<Outlet />}>
      <Route index element={<ModulePage title={pathsMap[PESSARY_FITTING]} />} />
      <Route
        path={NEW}
        element={<GRSInstrument module={PESSARY_FITTING} context={context} />}
      />
    </Route>
    <Route path={MEDICAL_ABORTION} element={<Outlet />}>
      <Route
        index
        element={<ModulePage title={pathsMap[MEDICAL_ABORTION]} />}
      />
      <Route
        path={NEW}
        element={<GRSInstrument module={MEDICAL_ABORTION} context={context} />}
      />
    </Route>
  </Route>
);
